import styled from "styled-components";

// Utils
import { media } from "utils/media";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
  gap: 30px;
  max-width: 500px;
  margin-top: 55px;

  ${media.PHONE`
    max-width: unset;
    margin-top: unset;
  `};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  max-width: 320px;
  gap: 18px;

  ${media.PHONE`
    flex-direction: column;
    gap: 15px;
    max-width: unset;
  `};
`;

export const LinkButton = styled.a`
  font-family: Avenir;
  border-radius: 6px;
  border: solid 1px;
  border-color: ${props =>
    props.color === "light"
      ? props.theme.colors.blue.colorLightBlueSocial
      : props.theme.colors.blue.colorDarkBlueSocial};
  background-color: ${props => props.theme.colors.white.colorWhite};
  cursor: pointer;
  text-decoration: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  background-color: ${props =>
    props.color === "light"
      ? props.theme.colors.blue.colorLightBlueSocial
      : props.theme.colors.blue.colorDarkBlueSocial};

  &:hover {
    text-decoration: none;
  }

  ${media.PHONE`
    width: 100%;
    text-align: center;
  `};
`;

export const Image = styled.img`
  width: 47px;
  height: 46px;
  border: solid 1px ${props => props.theme.colors.white.colorWhite};
  border-radius: 6px;
  background-color: ${props => props.theme.colors.white.colorWhite};
`;

export const Text = styled.p`
  font-family: Avenir;
  letter-spacing: 0.3px;
  color: ${props => props.theme.colors.white.colorWhite};
  user-select: none;
  font-weight: 500;
  margin: 0;
  width: 100%;
  text-align: center;
  &:hover {
    text-decoration: none;
  }
`;

export const ContainerMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  margin-top: -37px;
`;

export const Label = styled.p`
  color: ${props => props.theme.colors.black.colorBlack300};
  text-align: center;
  font-family: Avenir;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ButtonsContainerMobile = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
`;

export const LinkButtonMobile = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: solid 1px ${props => props.theme.colors.purple.colorPurple15};
  width: 34px;
  height: 34px;
`;

export const IconMobile = styled.img`
  height: 24px;
  width: 24px;
`;
